import React, { memo, useCallback, useEffect } from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  Close,
} from '@picsio/ui/dist/icons';
import { IconButton } from '@picsio/ui';

import picsioConfig from '../../../../../config';
import Logger from '../../services/Logger';
import ua from '../../ua';
import localization from '../../shared/strings';
import { navigate } from '../../helpers/history';
import Icon from '../Icon';
import Group from './Group';
import HelpButton from './HelpButton';
import Button from './Button';
import Logo from './Logo';
import Tooltip from '../Tooltip';

const ToolbarScreenTop = (props) => {
  const {
    title = [],
    unauthorized = false,
    helpLink = '',
    extra = null,
    onClose,
    helpText = '',
    onLogoClick = null,
    onCloseClick = null,
    onClickHandler = null,
  } = props;

  useEffect(() => {
    /**
     * Listen to press Esc
     * @param {KeyboardEvent} event
     */
    const closeListener = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };

    document.addEventListener('keydown', closeListener);
    window.dispatchEvent(new Event('screen:opened'));

    return () => {
      document.removeEventListener('keydown', closeListener);
      window.dispatchEvent(new Event('screen:closed'));
    };
  }, []);

  const handleLogoClick = useCallback((e) => {
    Logger.log('User', 'LogoClicked');

    if (picsioConfig.isPim) {
      navigate('/products');
      return;
    }

    if (onLogoClick) {
      onLogoClick(e);
    }

    onClose(e);
  }, [onClose, onLogoClick]);

  const onCloseButtonClick = useCallback((e) => {
    if (onCloseClick) {
      onCloseClick(e);
    }

    onClose(e);
  }, [onClose, onCloseClick]);

  return (
    <div className="toolbar toolbarCatalogTop toolbarScreenTop">
      <Group>
        <Choose>
          <When condition={!unauthorized && (ua.isMobileApp() || ua.browser.isNotDesktop())}>
            <Button id="button-backToCatalog" icon="regularPrevArrow" onClick={onClose} />
          </When>
          <Otherwise>
            <Logo
              handleLogoClick={unauthorized ? () => {} : (e) => handleLogoClick(e)}
              additionalClass={cn('logoPicsio', { disabled: unauthorized })}
            />
          </Otherwise>
        </Choose>
      </Group>
      <Group additionalClass="assetNameWrapper breadCrumbs">
        <ul>
          {title && title.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index + item}>{item}</li>
          ))}
        </ul>
      </Group>
      <Group>
        {helpLink && <HelpButton icon="question" tooltipPosition="bottom" component={helpLink} text={helpText} event="Help" onClickHandler={onClickHandler} />}
        {extra}
        <Choose>
          <When condition={unauthorized}>
            <span className="logoutLink" onClick={window.app.logout}>
              <Icon name="logout" />
              {localization.BILLING.logoutText}
            </span>
          </When>
          <When condition={!(ua.isMobileApp() || ua.browser.isNotDesktop())}>
            <Tooltip content={localization.TOOLBARS.titleClose} placement="bottom">
              <IconButton
                id="button-screenClose"
                className="toolbarButton"
                size="xxl"
                onClick={onCloseButtonClick}
              >
                <Close />
              </IconButton>
            </Tooltip>
          </When>
        </Choose>
      </Group>
    </div>
  );
};

ToolbarScreenTop.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.arrayOf(PropTypes.string),
  unauthorized: PropTypes.bool,
  helpLink: PropTypes.string,
  helpText: PropTypes.string,
  extra: PropTypes.node,
  onLogoClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  onClickHandler: PropTypes.func,
};

export default memo(ToolbarScreenTop);
